import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";
import { Loader } from "./Loader";
import { AppFooter } from "./AppFooter";
import { ConsentNotice } from "./ConsentNotice";

export function ProtectedLayout() {
  const { user } = useAuth();

  if (user === undefined) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-brand-bg">
        <Loader label="Loading TL-Thunderbird…" />
      </div>
    );
  }
  if (user === null) return <Navigate to="/login" replace />;

  return (
    <div className="min-h-screen bg-brand-bg">
      <Sidebar />
      <div className="lg:pl-[260px]">
        <Topbar />
        <main className="mx-auto max-w-7xl px-4 py-8 sm:px-8">
          <Outlet />
        </main>
        <AppFooter className="mx-auto max-w-7xl sm:px-8" />
      </div>
      <ConsentNotice />
    </div>
  );
}
